import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import axios from "../../../config/axios";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, TextField, Checkbox } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { showErrorIfNotDisplayed } from "../../../utils/snackbar";

export const CarrierAddOrEdit = ({ isOpen, handleClose, editCarrier }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCarrierSubmit = async event => {
    //Preventing page refresh
    event.preventDefault();

    setLoading(true);
    const body = {
      // password: event.target.password.value,
      latitude: event.target.latitude.value,
      longitude: event.target.longitude.value,
      name: event.target.name.value,
      area_name: event.target.area_name.value,
      is_active: event.target.is_active.checked
    };
    if (editCarrier) {
      if (event.target.email.value !== editCarrier.email) {
        body.email = event.target.email.value;
      }

      axios
        .patch(`/admin/update-carrier/${editCarrier._id}`, body)
        .then(res => {
          setLoading(false);
          handleClose();
          enqueueSnackbar(t("carriers.carrierUpdated"), { variant: "success" });
        })
        .catch(error => {
          // Use utility function that checks if error was already displayed
          showErrorIfNotDisplayed(error, enqueueSnackbar);
          setLoading(false);
        });
    } else {
      body.email = event.target.email.value;
      body.password = event.target.password.value;

      axios
        .post(`/admin/create-carrier`, body)
        .then(res => {
          setLoading(false);
          handleClose();
          enqueueSnackbar(t("carriers.carrierCreated"), { variant: "success" });
        })
        .catch(error => {
          // Use utility function that checks if error was already displayed
          showErrorIfNotDisplayed(error, enqueueSnackbar);
          setLoading(false);
        });
    }
  };

  const sendResetPasswordMail = () => {
    axios
      .post(`/recover-password`, { email: editCarrier.email })
      .then(res => {
        enqueueSnackbar(t("carriers.resetPasswordSent"), { variant: "success" });
      })
      .catch(error => {
        // Use utility function that checks if error was already displayed
        showErrorIfNotDisplayed(error, enqueueSnackbar);
      });
  };

  return (
    <Dialog fullWidth={true} maxWidth={"sm"} open={isOpen} onClose={handleClose} aria-labelledby="max-width-dialog-title">
      <DialogTitle id="max-width-dialog-title">{editCarrier ? t("carriers.editCarrier") : t("carriers.addCarrier")}</DialogTitle>
      <div className="carrier-popup">
        <form onSubmit={handleCarrierSubmit}>
          <div className="form-field">
            <div>{t("carriers.name")}</div>
            <div>
              <TextField id="outlined-basic" name="name" label={t("carriers.name")} variant="outlined" defaultValue={editCarrier?.name} required />
            </div>
          </div>
          <div className="form-field">
            <div>{t("carriers.email")}</div>
            <TextField id="outlined-basic" name="email" type="email" label={t("carriers.email")} variant="outlined" defaultValue={editCarrier?.email} required />
          </div>
          {!editCarrier && (
            <div className="form-field">
              <div>{t("carriers.password")}</div>
              <TextField
                id="outlined-basic"
                name="password"
                inputProps={{ minLength: 8 }}
                label={t("carriers.password")}
                defaultValue={editCarrier?.password}
                variant="outlined"
                required
              />
            </div>
          )}
          <div className="form-field">
            <div>{t("carriers.areaName")}</div>
            <TextField id="outlined-basic" name="area_name" label={t("carriers.areaName")} variant="outlined" defaultValue={editCarrier?.area_name} required />
          </div>
          <div className="form-field">
            <div>{t("carriers.latitude")}</div>
            <TextField id="outlined-basic" name="latitude" type="String" label={t("carriers.latitude")} variant="outlined" defaultValue={editCarrier?.latitude} required />
          </div>
          <div className="form-field">
            <div>{t("carriers.longitude")}</div>
            <TextField id="outlined-basic" name="longitude" type="String" label={t("carriers.longitude")} variant="outlined" defaultValue={editCarrier?.longitude} required />
          </div>
          <div className="form-field">
            <div>{t("carriers.isActive")}</div>
            <Checkbox name="is_active" defaultChecked={editCarrier?.is_active} />
          </div>

          {editCarrier && (
            <div className="form-field">
              <div>
                <Button onClick={sendResetPasswordMail} variant="outlined" color="primary">
                  {t("carriers.sendResetPasswordMail", "Send Reset Password Mail")}
                </Button>
              </div>
            </div>
          )}
          <div className="save-button">
            <Button type="submit" fullWidth variant="contained" color="primary" disabled={loading}>
              {loading ? t("common.loading") : t("common.save")}
            </Button>
            <Button onClick={handleClose} color="primary">
              {t("common.close")}
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
  );
};
